import React from 'react';
import MeasureGroupProgressiveList from './MeasureGroupProgressiveList';
import { MEASURE_GROUP_LIST_MASKS } from '../../utils/measureGroupListMasks';

export default function AnnealingProtocol(props) {
  return <MeasureGroupProgressiveList mask={MEASURE_GROUP_LIST_MASKS.annealingProtocol} {...props} />;
}
